import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';

export class AccordionBlockBloc extends BaseBloc {
  private readonly courseBloc = resolve(Blocs.userCourse);

  constructor(private readonly lessonId?: string) {
    super();
  }

  readonly loading = new LoadingState();
}
